import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Eemalda kõik

  <span style="color:#85c1dc;">**FI:**</span>
  Poista kaikki

  <span style="color:#85c1dc;">**RU:**</span>
  Удалить все
*/
/* @__NO_SIDE_EFFECTS__ */
const m290 = msg(
  mf`Eemalda kõik`,
  mf`Poista kaikki`,
  mf`Удалить все`,
)

export { m290 as 'w.module.filter_bar.remove_all' }